import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-phone-number-input/style.css';
import { selectors as sourceSelectors } from '../OrdersPage/reducer';
import { selectors as selectorsLogin } from '../LoginPage/reducer';
import * as actions from '../LoyaltyPage/actions';
import * as sourceActions from '../OrdersPage/actions';
import * as Styled from './LoyaltyPageReport.styles';
import networksArrow from '../../global/media/networks-arrow.svg';
import { formatTime } from '../../global/helpers';
import Button from '../../components/Button';
import CustomToggle from '../../components/CustomToggle';
import SearchModal from '../../components/SearchModal';
import { formatDataForLoyaltyReport } from '../LoyaltyPage/helpers';

const LoyaltyPageReport = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const dataUser = useSelector(selectorsLogin.userData);

  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [errorTooltip, setErrorTooltip] = useState<boolean>(false);

  const [pdfType, setPdf] = useState<boolean>(false);
  const [xlsxType, setXlsx] = useState<boolean>(false);
  const [sourcesOpen, setSourcesOpen] = useState<boolean>(false);

  const sources = useSelector(sourceSelectors.sourcesData)?.map((source) => {
    return {
      code: source.code,
      name: source.name,
    };
  });

  const [source, setSource] = useState<{ code: string; name: string }>({
    code: '',
    name: 'Все аптеки',
  });

  const handleSetSource = (code: string, name: string) => {
    setSource({
      code,
      name,
    });
  };

  useEffect(() => {
    if (dataUser) {
      dispatch(
        sourceActions.getSourcesByNetwork.request({
          networkCode: dataUser?.networkCode,
        })
      );
    }
  }, [dispatch, dataUser]);

  useEffect(() => {
    if (startDate && endDate) setErrorTooltip(false);
  }, [startDate, endDate]);

  const handleSentReport = () => {
    if (startDate && endDate && (pdfType || xlsxType)) {
      dispatch(
        actions.generateLoyaltyReport.request({
          data: formatDataForLoyaltyReport(
            new Date(startDate),
            new Date(endDate),
            'apteka_so_sklada',
            source.code
          ),
          pdf: pdfType,
          xls: xlsxType,
        })
      );
    } else setErrorTooltip(true);
  };

  const handleSetPdfType = (e: boolean) => {
    setPdf(e);
    setXlsx(!e);
  };

  const handleSetXlsType = (e: boolean) => {
    setXlsx(e);
    setPdf(!e);
  };

  return (
    <Styled.LoyaltyPageContainer>
      <Styled.PickersBlock>
        <Styled.PickersTop>
          <Styled.NetworkBlock>
            <div
              className="selected-network"
              onClick={() => setSourcesOpen(!sourcesOpen)}
            >
              {source.name}
              <img src={networksArrow} alt="networks-arrow" />
            </div>
            {sourcesOpen && (
              <SearchModal
                onClose={() => setSourcesOpen(false)}
                data={sources}
                setData={handleSetSource}
                variant="networks"
              />
            )}
          </Styled.NetworkBlock>
        </Styled.PickersTop>
        <Styled.PickersContainer>
          <Styled.Picker>
            <div className="label">{t('ReportPage.START_DATE_LABEL')}</div>
            <div className="day">{startDate && formatTime(startDate)}</div>
            <DatePicker
              locale="ru"
              selected={startDate}
              onChange={(date: any) => setStartDate(date)}
              timeInputLabel="Время:"
              dateFormat="MM/dd/yyyy HH:mm"
              showTimeInput
              inline
            />
          </Styled.Picker>
          <Styled.Picker>
            <div className="label">{t('ReportPage.END_DATE_LABEL')}</div>
            <div className="day">{endDate && formatTime(endDate)}</div>
            <DatePicker
              locale="ru"
              selected={endDate}
              onChange={(date: any) => setEndDate(date)}
              timeInputLabel="Время:"
              dateFormat="MM/dd/yyyy HH:mm"
              showTimeInput
              inline
            />
          </Styled.Picker>
          {dataUser?.networkCode === 'apteka_so_sklada' && (
            <Styled.GenerateButton>
              {errorTooltip && (
                <div className="error-tooltip">
                  {t('ReportPage.ERROR_TOOLTIP')}
                </div>
              )}
              <Button
                text={t('ReportPage.GENERATE_INVOICE_BTN')}
                onClick={handleSentReport}
              />
              <Styled.TogglesBlock>
                {/* <CustomToggle
                onChange={(e) => handleSetPdfType(e)}
                id="pdf"
                checked={pdfType}
                variant="standart"
                title=".pdf"
              /> */}
                <CustomToggle
                  onChange={(e) => handleSetXlsType(e)}
                  id="xls"
                  checked={xlsxType}
                  variant="standart"
                  title=".xlsx"
                />
              </Styled.TogglesBlock>
            </Styled.GenerateButton>
          )}
        </Styled.PickersContainer>
      </Styled.PickersBlock>
    </Styled.LoyaltyPageContainer>
  );
};

export default LoyaltyPageReport;
